import { useContext, useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { PublicRoutes } from "./routesDefinition/public-routes";
import { UserContext } from "./context/user.context";
import { isLoggedIn } from "./services/users.service";
import { useQuery } from "@tanstack/react-query";

function App() {
  const { updateUser } = useContext(UserContext);

  const handler = async () => {
    const data = await isLoggedIn();
    return data;
  };

  const { data } = useQuery({
    queryKey: ["isLoggedIn"],
    queryFn: handler,
    select: (data) => {
      return data;
    },
  });

  const router = createBrowserRouter(PublicRoutes(), {
    basename: "/",
  });

  useEffect(() => {
    if (data?.isLogged) {
      updateUser(data.user);
    }
  }, [data]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
